import '../style/cardStyle.css';
import { useSelector } from 'react-redux';
import CardCom from '../components/Card';
import { Typography } from '@mui/material';
import Progress from '../components/prograssBar';
import { Helmet } from 'react-helmet-async';

export default function AlathkarAmudafa() {
  const value = useSelector((state) => state.athkarMudafa.value); 
  const card = useSelector((state) => state.athkarMudafa.data); // Ensure this is the correct slice of state

  return (
    <>
    <Helmet>
        <title>الأذكار المضاعفة</title>
        <meta name='description' content='الأذكار المضاعفة' />
        <link rel="canonical" href="/AlathkarAlmudafa" />
    </Helmet>
    <div className='mainScreen'>
      <Progress value={value}/>
       <Typography variant="h3" component="p" className='title' sx={{ color: "text.primary"}}>الأذكار المضاعفة </Typography>
      <CardCom card={card} type={'athkarmudafa'}/>
    </div>

    </>
  );
}
